var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigDataAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 54.249,
    viewBox: "0 0 76 54.249",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Big_Data_Analysis",
    "data-name": "Big Data Analysis",
    transform: "translate(-1092.334 -676.861)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_89",
    "data-name": "Rectangle 89",
    width: 37,
    height: 39,
    transform: "translate(1092.334 676.861)",
    fill: "#294b6e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_166",
    "data-name": "Rectangle 166",
    width: 39,
    height: 39,
    transform: "translate(1129.334 676.861)",
    fill: "#6283a3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    width: 39,
    height: 6,
    transform: "translate(1092.334 715.861)",
    fill: "#6283a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M0,0H37.221V6.028H0Z",
    transform: "translate(1131.114 715.861)",
    fill: "#294b6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M5608.377-604l-5.876,9.283h23.705L5620.331-604Z",
    transform: "translate(-4484.535 1325.828)",
    fill: "#294b6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    d: "M5606.339-604l-3.838,9.283h15.487L5614.15-604Z",
    transform: "translate(-4479.959 1325.828)",
    fill: "#6283a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    d: "M5557.259-684h18.7",
    transform: "translate(-4458.928 1368.07)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    d: "M5557.259-684h34.767",
    transform: "translate(-4458.928 1372.41)",
    fill: "none",
    stroke: "#94e5ff",
    strokeLinecap: "square",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    d: "M5557.259-684h34.767",
    transform: "translate(-4458.928 1376.75)",
    fill: "none",
    stroke: "#94e5ff",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    d: "M5557.259-684h34.767",
    transform: "translate(-4458.928 1381.09)",
    fill: "none",
    stroke: "#94e5ff",
    strokeLinecap: "square",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    d: "M5557.259-684h19.891",
    transform: "translate(-4458.868 1385.43)",
    fill: "none",
    stroke: "#94e5ff",
    strokeLinecap: "square",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_91",
    "data-name": "Rectangle 91",
    width: 1,
    height: 7,
    transform: "translate(1101.334 705.861)",
    fill: "#ff8000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_92",
    "data-name": "Rectangle 92",
    width: 2,
    height: 9,
    transform: "translate(1106.334 703.861)",
    fill: "#ff8000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_93",
    "data-name": "Rectangle 93",
    width: 2,
    height: 5,
    transform: "translate(1110.334 707.861)",
    fill: "#ff8000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_94",
    "data-name": "Rectangle 94",
    width: 2,
    height: 8,
    transform: "translate(1116.334 704.861)",
    fill: "#ff8000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_95",
    "data-name": "Rectangle 95",
    width: 1,
    height: 8,
    transform: "translate(1122.334 704.861)",
    fill: "#ff8000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_96",
    "data-name": "Rectangle 96",
    width: 1,
    height: 15,
    transform: "translate(1136.334 697.861)",
    fill: "#ff8000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_98",
    "data-name": "Rectangle 98",
    width: 2,
    height: 18,
    transform: "translate(1141.334 694.861)",
    fill: "#ff8000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_99",
    "data-name": "Rectangle 99",
    width: 2,
    height: 18,
    transform: "translate(1147.334 694.861)",
    fill: "#ff8000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100",
    "data-name": "Rectangle 100",
    width: 2,
    height: 18,
    transform: "translate(1151.334 694.861)",
    fill: "#ff8000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_101",
    "data-name": "Rectangle 101",
    width: 2,
    height: 23,
    transform: "translate(1156.334 689.861)",
    fill: "#ff8000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_97",
    "data-name": "Rectangle 97",
    width: 1,
    height: 10,
    transform: "translate(1130.334 702.861)",
    fill: "#ff8000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    d: "M1.037,0A1.126,1.126,0,0,1,2.129,1.076l.155,5.87a.992.992,0,0,1-1.036,1.02A1.126,1.126,0,0,1,.156,6.891L0,1.021A.992.992,0,0,1,1.037,0Z",
    transform: "matrix(0.799, -0.602, 0.602, 0.799, 1156.319, 708.456)",
    fill: "#294b6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2668",
    "data-name": "Path 2668",
    d: "M5.208,0a5.075,5.075,0,0,1,5.208,4.931A5.075,5.075,0,0,1,5.208,9.862,5.075,5.075,0,0,1,0,4.931,5.075,5.075,0,0,1,5.208,0Z",
    transform: "translate(1149.43 698.826)",
    fill: "none",
    stroke: "#294b6e",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_92",
    "data-name": "Ellipse 92",
    cx: 4.5,
    cy: 4,
    rx: 4.5,
    ry: 4,
    transform: "translate(1150.334 699.861)",
    fill: "#fff",
    opacity: 0.42
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigDataAnalysis);
export default __webpack_public_path__ + "static/media/BigDataAnalysis.f58a2e3eea5a3ec5786991fd9f282cac.svg";
export { ForwardRef as ReactComponent };